/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { additionalQuestionIndex } from '../../axios/additionalQuestionIndex'
import type {
	AdditionalQuestionIndexError,
	AdditionalQuestionIndexPathParams,
	AdditionalQuestionIndexResponse,
} from '../../types/AdditionalQuestionIndex'

export const additionalQuestionIndexQueryKey = (form: AdditionalQuestionIndexPathParams['form']) =>
	[{ url: '/forms/:form/additional-questions', params: { form } }] as const

export type AdditionalQuestionIndexQueryKey = ReturnType<typeof additionalQuestionIndexQueryKey>

/** @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::index */
export function additionalQuestionIndexQueryOptions(
	form: AdditionalQuestionIndexPathParams['form'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AdditionalQuestionIndexResponse,
		AxiosError<AdditionalQuestionIndexError>,
		AdditionalQuestionIndexResponse,
		AdditionalQuestionIndexQueryKey
	>({
		queryKey: additionalQuestionIndexQueryKey(form),
		queryFn: ({ signal }) => additionalQuestionIndex(form, { signal, ...config }).then(res => res.data),
		enabled: !!form,
	})
}

/** @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::index */
export function useAdditionalQuestionIndex<TSelectData = AdditionalQuestionIndexResponse>(
	form: AdditionalQuestionIndexPathParams['form'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AdditionalQuestionIndexResponse,
					AxiosError<AdditionalQuestionIndexError>,
					TSelectData,
					AdditionalQuestionIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AdditionalQuestionIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...additionalQuestionIndexQueryOptions(form),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::index */
export function useAdditionalQuestionIndexSuspense<TSelectData = AdditionalQuestionIndexResponse>(
	form: AdditionalQuestionIndexPathParams['form'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AdditionalQuestionIndexResponse,
					AxiosError<AdditionalQuestionIndexError>,
					TSelectData,
					AdditionalQuestionIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AdditionalQuestionIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...additionalQuestionIndexQueryOptions(form),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
